import styles from "./FilterResultCount.module.css";

type FilterResultCountProps = {
  count: number;
  /** 세는 단위. 예) `개`. */
  unitLabel: string;
};

/**
 * 조회 결과 수. 필터 바가 아니라 표 위 띠(`ListToolbar`)가 이 자리를 갖는다 — 조건과 결과를
 * 같은 블록에 겹치면 어느 쪽이 바뀐 것인지 읽히지 않는다(규칙 §13).
 */
export function FilterResultCount({ count, unitLabel }: FilterResultCountProps) {
  return (
    <span className={styles.count} role="status">
      검색 결과: {count}
      {unitLabel}
    </span>
  );
}
